import { render, staticRenderFns } from "./InvitationsTable.vue?vue&type=template&id=283b5066&lang=html&"
import script from "./InvitationsTable.vue?vue&type=script&lang=js&"
export * from "./InvitationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports